import { useState } from 'react';
import Papa from 'papaparse';
import { bulkUploadContacts } from '../api/dbApi';
import Swal from 'sweetalert2';

export default function BulkUploadContactsModal({
  userId,
  onClose,
  onSaved
}) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = (file) => {
    setError('');
    if (!file) return;

    if (!file.name.endsWith('.csv')) {
      setError('Only CSV files are supported');
      return;
    }

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        if (!result.data.length) {
          setError('CSV file is empty or invalid');
          return;
        }
        setRows(result.data);
      }
    });
  };

  const submit = async () => {
    setError('');

    if (!rows.length) {
      setError('Please upload a CSV file first');
      return;
    }

    setLoading(true);

    try {
      const res = await bulkUploadContacts({
        user: userId,
        contacts: rows
      });

      if (res?.status === 200 || res?.success) {
        onSaved();
        onClose();
      } else {
        setError('Bulk upload failed. Please try again.');
      }
    } catch (err) {
      setError('Connection error. Please check your internet.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="custom-modal-backdrop" style={{ alignItems: 'center' }}>
      <div
        className="custom-modal border-0 shadow-lg"
        style={{
          maxWidth: '480px',
          width: '95%',
          borderRadius: '20px',
          overflow: 'hidden',
          padding: '0'
        }}
      >
        {/* HEADER */}
        <div className="bg-primary p-4 text-white text-center">
          <h5 className="fw-bold mb-0">📤 Bulk Upload Contacts</h5>
          <p className="mb-0 x-small text-white-50">
            Upload contacts using a CSV file
          </p>
        </div>

        {/* BODY */}
        <div className="p-4 bg-white">
          {error && (
            <div className="Swal Swal-danger py-2 border-0 shadow-sm mb-4 small fw-bold">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              {error}
            </div>
          )}

          {/* FILE INPUT */}
          <div className="mb-4">
            <label className="small fw-bold text-muted mb-2 text-uppercase">
              Upload CSV File
            </label>
            <input
              type="file"
              accept=".csv"
              className="form-control border-2 shadow-none"
              style={{ borderRadius: '12px', fontSize: '14px' }}
              onChange={(e) => handleFile(e.target.files[0])}
            />
            <div className="form-text x-small mt-2">
              CSV columns required: <b>name</b>, <b>number</b>
            </div>
          </div>

          {/* PREVIEW */}
          {rows.length > 0 && (
            <div className="mb-4">
              <div className="alert alert-light border small mb-0">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                <b>{rows.length}</b> contacts ready to upload
              </div>
            </div>
          )}

          {/* ACTIONS */}
          <div className="d-flex flex-column gap-2">
            <button
              className="btn btn-primary btn-lg w-100 fw-bold py-2 shadow-sm"
              style={{ borderRadius: '12px' }}
              onClick={submit}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Uploading...
                </>
              ) : (
                'Upload Contacts'
              )}
            </button>

            <button
              className="btn btn-light btn-sm w-100 py-2 text-muted"
              style={{ borderRadius: '12px' }}
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
